import { Dispatch } from 'react';
import { CoreApi } from '../../../api/api.apiclient';
import { PageRequest } from '../../../api/api.types';
import { ItemListFilters, ItemRequest } from '../../../api/core/core.types';
import {
  DELETE_ITEM,
  GET_ALL_ITEMS,
  GET_ITEM,
  GET_ITEM_LIST,
  POST_ITEM,
  PUT_ITEM,
  UPDATE_ITEM_FILTERS
} from '../types/item.types';

export const getItemList = (filters?: ItemListFilters, page?: PageRequest) => async (dispatch: Dispatch<any>) => {
  const response = await CoreApi.Items.listAllItems(filters, page);

  dispatch({
    type: GET_ITEM_LIST,
    payload: {
      page: response.data
    }
  });
  return Promise.resolve();
};

export const getAllItems = () => async (dispatch: Dispatch<any>) => {
  const response = await CoreApi.Items.listAllItemsAllPages();

  dispatch({
    type: GET_ALL_ITEMS,
    payload: {
      items: response
    }
  });

};

export const getItem = (id: number) => async (dispatch: Dispatch<any>) => {
  try {
    const response = await CoreApi.Items.getOneItem(id);

    dispatch({
      type: GET_ITEM,
      payload: {
        selectedItem: response.data
      }
    });
  } catch (e) {
    dispatch({
      type: GET_ITEM,
      payload: {
        selectedItem: null
      }
    });
  }
};

export const addNewItem = (request: ItemRequest) => async (dispatch: Dispatch<any>) => {
  const response = await CoreApi.Items.addNewItem(request);

  dispatch({
    type: POST_ITEM,
    payload: {
      success: true,
      newItem: response.data
    }
  });
};

export const deleteItem = (id: number) => async (dispatch: Dispatch<any>) => {
  await CoreApi.Items.deleteItem(id);
  dispatch({
    type: DELETE_ITEM,
    payload: {
      success: true
    }
  });
};

export const editItem = (id: number, request: ItemRequest) => async (dispatch: Dispatch<any>) => {
  const response = await CoreApi.Items.editItem(id, request);

  dispatch({
    type: PUT_ITEM,
    payload: {
      selectedItem: response.data
    }
  });
};

export const updateItemFilters = (filters: ItemListFilters) => async (dispatch: Dispatch<any>) => {
  dispatch({
    type: UPDATE_ITEM_FILTERS,
    payload: {
      filters
    }
  });
};
